import axios from "axios";
import {
  SETTINGS_TASK_STATUS_ERROR,
  SETTINGS_TASK_STATUS_CLEAR_SNACKBAR,
  SETTINGS_DELETE_TASK_STATUS_SUCCESS,
  SETTINGS_GET_TASK_STATUS_LOADING,
  SETTINGS_ADD_TASK_STATUS_ERROR,
  SETTINGS_ADD_TASK_STATUS_SUCCESS,
  SETTINGS_ADD_TASK_STATUS,
  SETTINGS_GET_TASK_STATUS,
} from "../constants/types";
import queryString from "query-string";

// import { bulkUploadFiles } from "./documentsActions";

import { server_url } from "../constants/types";
import request from "config/api";

export const fetchTaskStatus = (params = {}) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_TASK_STATUS_LOADING,
        payload: {
          loading: true,
        },
      });
      const newParams = {
        PageNumber: params.page ? params.page + 1 : 1,
        PageSize: params.pageSize ? params.pageSize : 10,
      };
      const queryParams = queryString.stringify(newParams);

      request({
        url: `${server_url}/TaskStatus`,
        method: "GET",
      })
        .then((response) => {
          dispatch({
            type: SETTINGS_GET_TASK_STATUS,
            payload: {
              statusName: response.data,
              totalCount: response.data.length,
              loading: false,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_TASK_STATUS_ERROR,
            payload: {
              status: "error",
              text: "Error occured during getting all TaskStatus.",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const addUpdateTaskStatus = ({ formData, onSuccess, payload }) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_ADD_TASK_STATUS,
        payload: {
          loading: true,
        },
      });

      let data = {
        ...formData,
      };

      request({
        method: formData.taskStatusId ? "PUT" : "POST",
        url: `${server_url}/TaskStatus${
          formData.taskStatusId ? `/${formData.taskStatusId}` : ""
        }`,
        body: { ...data, listingOrder: data.listingOrder + 1 },
      })
        .then(async (response) => {
          onSuccess();

          dispatch({
            type: SETTINGS_ADD_TASK_STATUS_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: formData.taskStatusId
                ? "TaskStatus updated Successfully"
                : "TaskStatus Created Successfully",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_ADD_TASK_STATUS_ERROR,
            payload: {
              text: "Error occurred during creating taskStatus data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const taskStatusDelete = ({
  taskStatusId,
  pageModel,
  onSuccess = () => {},
  showSnackbar = true,
}) => {
  console.log("Check the taskStatusDelete Action", taskStatusId);
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_TASK_STATUS_LOADING,
        payload: {
          loading: true,
        },
      });
      request({
        url: `${server_url}/TaskStatus/${taskStatusId}`,
        method: "DELETE",
      })
        .then((response) => {
          dispatch(fetchTaskStatus({ ...pageModel }));
          onSuccess();

          dispatch({
            type: SETTINGS_DELETE_TASK_STATUS_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: "taskStatus Deleted Successfully",
              loading: false,
              showSnackbar: true,
            },
          });

          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_TASK_STATUS_ERROR,
            payload: {
              text: "Error occurred during deleting taskStatus data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const taskStatusClearShowSnackbar = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SETTINGS_TASK_STATUS_CLEAR_SNACKBAR,
    });
  };
};
